module.exports = __webpack_public_path__ + "img/stock14.6f33754e.png";